import { Component, input } from '@angular/core';
import { PreloaderComponent } from '../preloader/preloader.component';


@Component({
  selector: 'tc-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [
    PreloaderComponent,
  ],
})
export class ButtonComponent {
  buttonType = input<'button' | 'submit'>('button');

  isTransparent = input<boolean>(false);
  isStyleDefault = input<boolean>(false);
  isSmall = input<boolean>(false);
  isBig = input<boolean>(false);
  isBold = input<boolean>(false);

  isDisabled = input<boolean>(false);
  isLoading = input<boolean>(false);
}
